﻿import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import 'rxjs/add/operator/pairwise';
// APP
import { InformationService } from '../../../services/information.service';
import { BuildingService } from '../../../services/building.service';
import { SharedService } from '../../../services/shared.service';
import { BuildingType } from '../../../viewmodel';
import { BuildingQuestionParam } from '../../../viewmodel';
import { Animations } from '../../common/animations';
import { CustomValidators } from '../../../directives/validators/custom-validator.directive';
import { FoucsChangeService } from '../../../services/focuschange.service';

@Component({
    selector: 'app-buildingtype',
    templateUrl: './buildingtype.component.html',
    providers: [InformationService, BuildingService],
    animations: [Animations.flyInOut]
})
export class BuildingTypeComponent implements OnInit {
    animate: string = 'active';
    title: string = 'Building Type';
    projectId: number = 0;
    buildingId: number = 0;
    projBuildingId: number = 0;
    devProjectBuildingId: number = 0;
    siteProjectBuildingId: number = 0;
    trackingId: number = 0;
    entityId: number = 0;
    questionType: number = 708;
    buildingAddress: string = '';
    buildingAddr: string = ''; 
    HFO: string = 'N'; //Housing fund Option
    pageError: any = [];
    pageSuccess: any = [];
    isEdit: boolean = false;
    submitted: boolean = false;
    questionForm: FormGroup;
    model: BuildingType;
    showYesMessage: boolean = false;
    showNoMessage: boolean = false;

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService
        , private foucsChangeService: FoucsChangeService) {

        this.model = new BuildingType();
        this.model.ProjectId = this.projectId;
    }
    ngOnInit() {

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null)
                this.projectId = this.model.ProjectId = ids.projectId;
        }
        else {
            if (this.model.ProjectId == 0 && this.projectId == 0)
                this.sharedService.navigateHome();
        }

        let bqp = this.sharedService.getJsonData('BuildingQuestionParam');
        if (bqp != null) {
            this.devProjectBuildingId = this.model.DevProjectBuildingId = bqp.devProjectBuildingId;
            this.siteProjectBuildingId = this.model.SiteProjectBuildingId = bqp.siteProjectBuildingId;
            this.buildingId = this.model.BuildingId = bqp.bldgId;
            this.projBuildingId = this.devProjectBuildingId == null ? this.siteProjectBuildingId : this.devProjectBuildingId;
            if (bqp.buildingAddress != null || bqp.buildingAddress == '') {
                this.buildingAddress = '- ' + bqp.buildingAddress;
                this.buildingAddr = bqp.buildingAddress; 
            }
        }
        else {
            this.sharedService.navigateSummary();
        }
        if (this.projBuildingId == null || this.buildingId == null)
            this.sharedService.navigateSummary();

        this.questionForm = this.frmBuilder.group({
            buildingType: [null, [Validators.required]]
            
        });

        //check the payment In Liu info and valid to browse
        this.informationService.getQuestionByType(this.projectId, 'AHF')
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {
                        this.HFO = success.Result.Hfo;
                        if (this.HFO != 'N') {
                            this.sharedService.navigateSummary();
                        }
                    }
                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })

        //get Building Type
        this.informationService.GetProjectBuildingType(this.devProjectBuildingId, this.siteProjectBuildingId)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {
                        
                        this.model = success.Result;
                         
                        if (success.Result.IsDev == null)
                            this.model.IsDevBuilding = null;
                        else if (success.Result.IsDev == true) {
                            this.model.IsDevBuilding = 'Y';
                            this.isEdit = true;
                        }
                        else if (success.Result.IsDev == false) {
                            this.model.IsDevBuilding = 'N';
                            this.isEdit = true;
                        }                        
                        
                    }
                    if (this.model.ProjectId == 0 && this.projectId == 0) {
                        this.showError("Project ID not found!")
                    }
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })
    }

    save(button) {
        this.submitted = true;
        if (this.model.IsDevBuilding == null) {
            return false;
        }
        else if (this.model.IsDevBuilding == 'Y' || this.model.IsDevBuilding == 'N') {
            if (this.model.IsDevBuilding == 'Y')
                this.model.IsDev = true;
            else if (this.model.IsDevBuilding == 'N')
                this.model.IsDev = false; 
        }  

        this.model.IsValid = true;
        this.informationService.SaveProjectBuildingType(this.model)
            .subscribe(
            success => {
                if (!success.Success) {
                    this.showError(success.StatusMessage);
                }
                else {

                    if (button == 'NEXT') {                      
                        var path = ''; 
                        if (this.model.IsDev == true)
                            path = '/buildings/mihoptions'; 
                        else if (this.model.IsDev == false) 
                            path = '/buildings/locationmihsiteunit'; 

                        this.sharedService.setBuildingQuestionParam(success.Result, this.buildingAddr);
                        this.router.navigate([path]);
                    }
                    else if (button == 'LATER')
                        this.sharedService.navigateSummary();
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })
    }

    previous() {
        this.router.navigate(["/buildings/publicfunding"]);
    }
    home() {
        this.sharedService.navigateHome();
    }

    setBuildingQuestionParam(building) {

        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingId;
        BQP.siteProjectBuildingId = building.SiteProjectBuildingId;
        BQP.bldgId = building.BuildingId;
        BQP.mood = 'A';
        this.sharedService.setJsonData('BuildingQuestionParam', BQP);
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }
    
  /**** Edit building Type and popup section    ****/
    changeBuildingType() {
        if (this.model.IsDevBuilding == 'Y' && this.isEdit) {
            this.showYesMessage = true;
            this.foucsChangeService.changeFocus(false);
        }
        else if (this.model.IsDevBuilding == 'N' && this.isEdit) {
            this.showNoMessage = true;
            this.foucsChangeService.changeFocus(false);
        }
    }

    buildingTypeYes(button) {
        if (button == 'cancel') {
            this.model.IsDevBuilding = 'N'; 
            this.showYesMessage = false;
            this.foucsChangeService.changeFocus(true);
        }
        else if (button == 'continue') {
            this.model.IsDevBuilding = 'Y';
            this.showYesMessage = false;
            this.foucsChangeService.changeFocus(true);
        }
    }   

    buildingTypeNo(button) {
        if (button == 'cancel') {
            this.model.IsDevBuilding = 'Y';
            this.showNoMessage = false;
            this.foucsChangeService.changeFocus(true);
        }
        else if (button == 'continue') {
            this.model.IsDevBuilding = 'N';
            this.showNoMessage = false;
            this.foucsChangeService.changeFocus(true);
        }

    }




}
